import { TabItem } from './SolutionSubmissionTabs';

export const solutionTabs: TabItem[] = [
  {
    name: 'register',
    display: '1. Register a Solution',
    navigateTo: '/solution/create',
    tooltip: {
      title: 'Register Solution',
      content: 'Register by providing the basic details for your solution.',
    },
  },
  {
    name: 'define',
    display: '2. Define a Solution',
    navigateTo: '/solution/define',
    tooltip: {
      title: 'Define Solution',
      content: 'Define the solution by selecting relevant apps.',
    },
  },
  {
    name: 'artifacts',
    display: '3. Solution Artifacts',
    navigateTo: '/solution/artifacts',
    tooltip: {
      title: 'Solution Artifacts',
      content:
        'Provide additional details before submitting your solution for review.',
    },
  },
];
